import React from 'react'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { EmptyIcon } from '@frontend/pole-ui/lib/components/Icon/svg/EmptyIcon'
import { Fading } from '../animations'
import type { IRoundedMarkProps } from './interfaces'

const RoundedMark: React.FC<IRoundedMarkProps> = ({ isVisible, color, className }) => (
  <Fading isVisible={isVisible as boolean}>
    <span className={className}>
      <Icon style={{ color }} component={<EmptyIcon />} size={EIconSize.XS} />
    </span>
  </Fading>
)

export default RoundedMark
